import { render, staticRenderFns } from "./HoldButton.vue?vue&type=template&id=2f146f5b&scoped=true&"
import script from "./HoldButton.vue?vue&type=script&lang=js&"
export * from "./HoldButton.vue?vue&type=script&lang=js&"
import style0 from "./HoldButton.vue?vue&type=style&index=0&id=2f146f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f146f5b",
  null
  
)

export default component.exports